import { render, staticRenderFns } from "./SuccessRegistration.vue?vue&type=template&id=36775100&scoped=true"
import script from "./SuccessRegistration.vue?vue&type=script&lang=js"
export * from "./SuccessRegistration.vue?vue&type=script&lang=js"
import style0 from "./SuccessRegistration.vue?vue&type=style&index=0&id=36775100&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36775100",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2326903440/src/bitbucket.org/Modis-ito/frontend-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36775100')) {
      api.createRecord('36775100', component.options)
    } else {
      api.reload('36775100', component.options)
    }
    module.hot.accept("./SuccessRegistration.vue?vue&type=template&id=36775100&scoped=true", function () {
      api.rerender('36775100', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/common/pages/login/SuccessRegistration.vue"
export default component.exports